import { createFileRoute } from '@tanstack/react-router';
import { CreateCoursePage } from '@/pages/courses/CreateCoursePage';

export const Route = createFileRoute('/_authenticated/_app/courses/create')({
	component: CreateCoursePage,
});
